var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 0H3.5C1.8125 0 0.5 1.375 0.5 3V25C0.5 26.6875 1.8125 28 3.5 28H25.5C27.125 28 28.5 26.6875 28.5 25V3C28.5 1.375 27.125 0 25.5 0ZM26.5 25C26.5 25.5625 26 26 25.5 26H3.5C2.9375 26 2.5 25.5625 2.5 25V3C2.5 2.5 2.9375 2 3.5 2H25.5C26 2 26.5 2.5 26.5 3V25ZM14.5 19.25C13.5 19.25 12.75 20.0625 12.75 21C12.75 22 13.5 22.75 14.5 22.75C15.4375 22.75 16.25 22 16.25 21C16.25 20.0625 15.4375 19.25 14.5 19.25ZM14.9375 17.75C15.375 17.75 15.6875 17.4375 15.6875 17C15.6875 14.3125 20.5625 14.5 20.5625 10.3125C20.5625 7.125 17.6875 5.25 14.4375 5.25C11.625 5.25 10.0625 6.375 8.75 8.0625C8.5 8.4375 8.5625 8.875 8.9375 9.125L9.75 9.75C10.0625 9.9375 10.5 9.875 10.75 9.5625C11.6875 8.375 12.625 7.75 14.4375 7.75C16.9375 7.75 18.0625 9.0625 18.0625 10.3125C18.0625 13 13.1875 12.625 13.1875 17C13.1875 17.4375 13.5625 17.75 13.9375 17.75H14.9375Z",
    fill: "#605FF3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.89a5946e.svg";
export { ForwardRef as ReactComponent };